import { Component, input } from '@angular/core';

@Component({
  selector: 'app-arrow-nav-icon',
  imports: [],
  templateUrl: './arrow-nav-icon.html',
  styleUrl: './arrow-nav-icon.scss',
})
export class ArrowNavIcon {
  direction = input<'left' | 'right'>('right');
  variant = input<'chevron' | 'arrow'>('chevron');
}
